// App.jsx
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import CategoryPage from "./pages/CategoryPage";
import FabricPage from "./pages/FabricPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import { ToastContainer } from "react-toastify";
import BackgroundWrapper from "./components/ui/BackgroundWrapper";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./styles/reveal.css";

import aboutbkgnd from "./assets/about.jpg";
import contactbkgnd from "./assets/contacts1.jpg";

function BackgroundLayout({ children }) {
  const location = useLocation();

  // подбираем фон в зависимости от маршрута
  let backgroundImage = null;
  if (location.pathname === "/") {
    backgroundImage = null;
  } else if (location.pathname.startsWith("/about")) {
    backgroundImage = aboutbkgnd;
  } else if (location.pathname.startsWith("/contact")) {
    backgroundImage = contactbkgnd;
  } else {

  }

  return (
    <BackgroundWrapper image={backgroundImage}>
      {children}
    </BackgroundWrapper>
  );
}

function App() {
  return (
    <Router>
      <BackgroundLayout>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/category/:id" element={<CategoryPage />} />
              <Route path="/fabric/:id" element={<FabricPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </main>
          <Footer />
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        </div>
      </BackgroundLayout>
    </Router>
  );
}

export default App;
